import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'gossamer-front-end';
import { BookingList } from './WebsiteAccountLists';

export const WebsiteAccountOnDemandEventsPage = (): React.JSX.Element => {
  const user = useSelector(selectUser);
  return (
    <BookingList
      query={{
        where: {
          and: [
            { fieldId: 'user_id', operator: 'eq', value: user?.userId || '' },
            { fieldId: 'flow_option', operator: 'eq', value: 'none' },
          ],
        },
        order: [['start_at', 'DESC']],
        offset: 0,
        limit: 50,
      }}
      emptyText="No on-demand events."
    />
  );
};
